module.exports = __webpack_public_path__ + "img/content5.67ddf53b.png";